<template>
<main class="registration-container contact-compilation">
  <div class="registration">
    <Logo />

    <h1 class="registration__title">Skapa ett konto</h1>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sed tellus nibh. Aliquam posuere molestie ante, at lacinia nisi rutrum quis.</p>

    <section class="registration__middle">
      <h2 class="registration__subtitle">Identifiering och signering</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil animi nemo dolorum, voluptates consequatur reiciendis dolor ut voluptatum qui rem accusantium eum expedita doloribus fuga numquam dicta. Voluptates, modi similique!</p>

      <div class="registration__content-container">
        <div class="registration__contact">
          <label>E-postadress:<br/>
            <input type="email" v-model="email" placeholder="me@example.com">
          </label>

          <label>Mobilnummer:<br/>
              <span>
                <input type="tel" v-model="phoneCode" placeholder="+46">
                <input type="tel" v-model="phone" placeholder="767018111">
              </span>
          </label>

          <label>
            <input type="checkbox" v-model="agreement">
            Jag godkänner <a class="link link--green" href="#">Avtal och villkor</a>
          </label>

          <Button
            v-if="user.status == 'loaded'"
            msg="Skapa konto"
            @click.native="updateUser"
            :class="'button button--primary'"
          />
          <LoadingSpinner v-if="user.status == 'uploading'" />
        </div>
      </div>
    </section>

    <RegistrationFooter/>
  </div>
</main>
</template>

<script>
import Button from '../components/elements/Button';
import LoadingSpinner from '../components/elements/LoadingSpinner';
import RegistrationFooter from '../components/elements/RegistrationFooter';
import Logo from '../components/elements/Logo';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Contact',
  data () {
    return {
      email: '',
      phone:'',
      phoneCode:'+46',
      agreement:false
    }
  },
  components: { Button, LoadingSpinner, Logo, RegistrationFooter },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['updateContact']),
    validate () {
      let path = "^\\+46[0-9]{9}$"
      let regexp = new RegExp(path);
      return regexp.test(`${this.phoneCode}${this.phone}`);
    },
    updateUser () {
      if (this.validate() && this.agreement) {
        this.updateContact({
          contact: {
            email:this.email,
            phone:`${this.phoneCode}${this.phone}`,
            status:'completed'
          }
        }).then(()=>{
          this.$router.push('/register/fullmakt')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-compilation {
  background: transparent linear-gradient(248deg, #0066A1 0%, #003f63 100%) 0% 0% no-repeat padding-box;
}

.registration__contact {
  display: flex;
  flex-direction: column;
  text-align: left;

  > label,label>span {
    font-size: 1rem;
    font-family: "Roboto", sans-serif;

    > input:not([type='checkbox']) {
      margin: .6em auto 1.2em auto;
      width: 100%;
      height: 3rem;
      padding: 0.5em;
      font-size: 1rem;
      color: #707070;
    }

    > input[type='checkbox'] {
      margin-left: 0;
      margin-right: .5em;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  >label>span{
    display: flex;
    input[type='tel']{
      &:first-of-type{
        width: 4rem;
      }
    }
  }
  > label:nth-child(3) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .v-spinner {
      margin-top: 2em;
  }
}
</style>